const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectTypeCircleRewilding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#5F9375",
    style: {
      stroke: "#5F9375",
      stroke: "color(display-p3 0.3725 0.5765 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2004_4223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7642 24.0142C9.60093 21.1404 8.992 18.2647 7.93626 15.3855C7.69877 14.7377 8.52309 14.2324 8.99254 14.738C10.0459 15.8724 10.9059 17.041 11.5711 18.2428C11.2092 15.8403 10.6256 13.2961 9.81992 10.6105C9.63769 10.003 10.3639 9.53572 10.8412 9.95335C12.9006 11.7553 14.3543 14.1847 15.206 17.2287C16.3195 13.353 18.3723 9.98276 21.3627 7.12835C21.8426 6.67022 22.614 7.16687 22.3957 7.79334C20.9359 11.9821 19.9408 15.7014 19.4085 18.9485C20.3333 17.4731 21.6298 16.0498 23.293 14.6802C23.8198 14.2463 24.565 14.8401 24.2598 15.4505C22.829 18.3121 22.0207 21.1655 21.8313 24.0142H26.2221C26.5711 24.0142 26.854 24.2971 26.854 24.6461C26.854 24.9951 26.5711 25.278 26.2221 25.278H6.002C5.65302 25.278 5.37012 24.9951 5.37012 24.6461C5.37012 24.2971 5.65302 24.0142 6.002 24.0142H9.7642ZM17.6853 24.0142C17.6963 20.2316 18.5621 15.616 20.2785 10.1604C17.1967 13.9632 15.6008 18.5738 15.4868 24.0142H17.6853ZM14.5481 20.2374C14.1031 17.2112 13.1658 14.7332 11.7393 12.7921C12.7815 16.8564 13.2951 20.5968 13.2781 24.0143H14.2227C14.2491 22.7083 14.3575 21.4493 14.5481 20.2374ZM10.168 18.3427C10.6397 20.2322 10.9271 22.1229 11.0299 24.0143H11.9878C11.8813 22.0523 11.2768 20.1634 10.168 18.3427ZM20.5648 24.0142C20.6955 21.9241 21.1389 19.8361 21.894 17.7515C20.1007 19.7622 19.1349 21.8479 18.9783 24.0142H20.5648Z",
    fill: "#5F9375",
    style: {
      fill: "#5F9375",
      fill: "color(display-p3 0.3725 0.5765 0.4588)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2004_4223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4839,
    height: 21.4839,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(5.37085 5.37097)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCircleRewilding);
export default __webpack_public_path__ + "static/media/project-type-circle-rewilding.74e2198a75b0d1f831b1eefa8cce8256.svg";
export { ForwardRef as ReactComponent };